export default __webpack_public_path__ + "f4d3c5e28ed7c79ec7fee19f6aac2d1e.svg";